import { applyFilters, doRequest } from "./helpers";

export default class MetaAdService {
  static async list(accountId, filters = null) {
    let path = `/meta_ad_account/${accountId}/ads`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
